import { render, staticRenderFns } from "./SampleCheckoutItem.vue?vue&type=template&id=137f3c78&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SampleCheckoutItem.vue?vue&type=script&lang=js&"
export * from "./SampleCheckoutItem.vue?vue&type=script&lang=js&"
import style0 from "./SampleCheckoutItem.vue?vue&type=style&index=0&id=137f3c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f3c78",
  null
  
)

export default component.exports